import React, { useMemo } from 'react'
import { map, uniq, sortBy, toString, startCase } from 'lodash'

import Filters from 'Features/Filters'
import { arrayToOptions } from 'Utilities/selectOptions'

const getFromAssets = (assets, field) => sortBy(uniq(map(assets, field)))
const capitalizeSplit = (string) => {
  if (string === 'N/A') { return string }

  return toString(string).split(/(?=[A-Z])/).join(' ')
}
const defaultFilters = {
  // locations: 'All',
  dataProtectionCompliance: 'All',
  dataProtectionStatus: 'All',
  monitoringCompliance: 'All',
  antivirusCompliance: 'All',
  antivirusStatus: 'All',
  patchingCompliance: 'All',
  patchingStatus: 'All',
  deviceType: 'All',
  powerState: 'All',
  customerStatus: 'All',
  deviceLastSeen: 'All',
  osSupported: 'All'
}

const OnPremiseReportFilters = ({ filters = {}, changeFilters, assets }) => {
  const coverageOptions = useMemo(() => [
    { value: 'Yes', label: 'Yes' },
    { value: 'No', label: 'No' }
  ])
  const booleanOptions = useMemo(() => [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' }
  ])
  // const locations = useMemo(() => arrayToOptions(getFromAssets(assets, 'location')))
  const monitoringCompliances = useMemo(() => arrayToOptions(getFromAssets(assets, 'monitoring_compliance'), capitalizeSplit))
  const antivirusCompliances = useMemo(() => arrayToOptions(getFromAssets(assets, 'antivirus_compliance'), capitalizeSplit))
  const antivirusStatuses = useMemo(() => arrayToOptions(getFromAssets(assets, 'antivirus_status'), capitalizeSplit))
  const patchingStatuses = useMemo(() => arrayToOptions(getFromAssets(assets, 'patching_status'), capitalizeSplit))
  const patchingCompliances = useMemo(() => arrayToOptions(getFromAssets(assets, 'patching_compliance'), capitalizeSplit))
  const dataProtectionCompliances = useMemo(() => arrayToOptions(getFromAssets(assets, 'data_protection_compliance'), capitalizeSplit))
  const dataProtectionStatuses = useMemo(() => arrayToOptions(getFromAssets(assets, 'data_protection_status'), capitalizeSplit))
  const deviceTypes = useMemo(() => arrayToOptions(getFromAssets(assets, 'device_type')))
  const powerState = useMemo(() => arrayToOptions(getFromAssets(assets, 'power_state')))
  const osSupportedOptions = useMemo(() => arrayToOptions(getFromAssets(assets, 'os_supported')))
  const customerStatuses = useMemo(() => arrayToOptions(['live', 'historic', 'pending offboarding'], startCase))
  const lastSeenOptions = useMemo(() => [
    { value: 'Currently online', label: 'Currently online' },
    { value: [0, 0], label: 'Today' },
    { value: [1, 7], label: 'Last week' },
    { value: [8, 30], label: 'Last 30 days' },
    { value: [31, 60], label: 'Last 60 days' },
    { value: [61, 90], label: 'Last 90 days' },
    { value: [91, 100], label: 'More than 90 days' },
  ])

  return (
    <Filters {...{ filters, onChange: changeFilters, shareable: true }}>
      <div className="col">
        <div className='row mb-3'>
          {/* <Filters.Select {...{ filterName: 'locations', label: 'Locations', options: locations }} /> */}
          <Filters.Select {...{ filterName: 'deviceType', label: 'Device Types', options: deviceTypes }} />
          <Filters.Select {...{ filterName: 'powerState', label: 'Power State', options: powerState }} />
          <Filters.Select {...{ filterName: 'deviceLastSeen', options: lastSeenOptions, sortOptions: false }} />
          <Filters.Select {...{ filterName: 'osSupported', label: 'OS Supported', options: osSupportedOptions, sortOptions: false }} />
        </div>

        <div className='row mb-3'>
          <Filters.Select {...{ filterName: 'dataProtectionCompliance', label: 'Data Protection Compliance', options: dataProtectionCompliances, className: 'col-3' }} />
          <Filters.Select {...{ filterName: 'patchingCompliance', label: 'Patching Compliance', options: patchingCompliances, className: 'col-3' }} />
          <Filters.Select {...{ filterName: 'antivirusCompliance', label: 'AntiVirus Compliance', options: antivirusCompliances, className: 'col-3' }} />
          <Filters.Select {...{ filterName: 'monitoringCompliance', label: 'Monitoring Compliance', options: monitoringCompliances }} />
        </div>

        <div className='row'>
          <Filters.Select {...{ filterName: 'dataProtectionStatus', label: 'Data Protection Status', options: dataProtectionStatuses, className: 'col-3' }} />
          <Filters.Select {...{ filterName: 'patchingStatus', label: 'Patching Status', options: patchingStatuses, className: 'col-3' }} />
          <Filters.Select {...{ filterName: 'antivirusStatus', label: 'AntiVirus Status', options: antivirusStatuses, className: 'col-3' }} />
        </div>
      </div>
    </Filters>
  )
}

export { OnPremiseReportFilters as Filters, defaultFilters }
